import React, {Suspense} from "react"
import {Box} from "zmp-ui"
import {CartItems} from "./cart-item"
import {OrderNote} from "./components/orderNote"
import {DeliveryInformation} from "./components/deliveryInfomation"
import {ButtonOrder} from "./components/button"
import {Divider} from "../../component/divider";
import {Section} from "../../component/section";
import {PowerBy} from "../../component/powerBy";
import {SheetDeliveryStrange} from "./components/productAttributes";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {attributeSheetState} from "../../state";

export const Cart = () => {
   const attributeSheet = useRecoilValue(attributeSheetState)
   const setAttributeSheet = useSetRecoilState(attributeSheetState)
   return (
      <div className="relative flex-1 flex flex-col bg-white shopping-cart__content">
         <Divider/>
         <ProductList/>
         <Divider/>
         <DeliveryInformation/>
         <Divider/>
         <OrderNote/>
         <Divider/>
         <ButtonOrder/>
         <PowerBy/>
         <SheetDeliveryStrange sheetVisible={attributeSheet} onDisplay={setAttributeSheet}/>
      </div>
   )
}

export const ProductListContent = () => {
   return (
      <Section>
         <Box>
            <CartItems/>
         </Box>
      </Section>
   )
}

export const ProductList = () => {
   return (
      <Suspense>
         <ProductListContent/>
      </Suspense>
   )
}
